import React from 'react';
import { Box } from '@mui/material';

import PostDescription from '../../../DesignSystem/PostDescription';
import PublicationAlert from '../../Shared/PublicationAlert';
import PostLocation from '../../Shared/PostLocation';
import { moment } from '../../../../I18n';
import VideoEmbed from '../../../DesignSystem/VideoEmbed';
import EventUrlState from '../../../DesignSystem/EventUrlState';
import AttachmentLinksList from '../../Shared/AttachmentLinksList';
import PostSidePrimaryActions from './PostSidePrimaryActions';
import useWidth from '../../../../Hooks/useWidth';

function CommunicationShow({ post }: any) {
  const isMobile = useWidth('down', 'md');

  const isPublished = post.published_at && moment(post.published_at).isBefore();
  const [lat, lng] = (post.latlng || '').split(',');

  return (
    <>
      {!isPublished && (
        <Box sx={{ mb: 3 }}>
          <PublicationAlert askToPublishAt={post.ask_to_publish_at} />
        </Box>
      )}
      <Box sx={{ mb: 3 }}>
        <PostDescription content={post.content} />
        <AttachmentLinksList attachments={post.attachments} />
      </Box>
      {post.video_embed && (
        <Box sx={{ mb: 3, width: '100%' }}>
          <VideoEmbed title={post.title} src={post.video_embed} />
        </Box>
      )}
      {post.event_url && (
        <>
          <Box sx={{ mb: 3 }}>
            <EventUrlState url={post.event_url} startAt={post.start_at} endAt={post.end_at} />
          </Box>
          {isMobile && (
            <Box sx={{ mb: 2 }}>
              <PostSidePrimaryActions post={post} />
            </Box>
          )}
        </>
      )}
      <PostLocation label={post.location} lat={lat} lng={lng} status={post.status} />
    </>
  );
}

export default CommunicationShow;
